import {Component, ElementRef, Input} from '@angular/core';
import {Util} from "../../app/util";
import {CONFIG} from "../../app/config";
import {NavController} from "ionic-angular";
import {LogadoService} from "../../providers/logado-service";

@Component({
    selector: 'app-feedback',
    templateUrl: 'app-feedback.html',
    providers: []
})
export class AppFeedback {

    config: any;
    logado: any;

    @Input('starico') starico: 'star' | 'icon';
    @Input('tamanho') tamanho: 'small' | 'medio' | 'biger' | 'linha' | 'clear';
    @Input('border') border: boolean;
    @Input('disable') disable: boolean;
    @Input('branded') branded: any;
    @Input('setstar') setstar: number;
    @Input('setqtde') setqtde: number;
    @Input('hotspotID') hotspotID: number;

    constructor(public element: ElementRef, public navCtrl: NavController, public util: Util,
                public logadoService: LogadoService) {

        this.config = CONFIG;
        this.logado = this.logadoService.getAuth();

    }

    feedtype(result: 'color' | 'stars' | 'style', star?) {

        let color = (this.setstar > star ? this.branded.BrandedCora : 'CorInox');

        let stars = {
            'cursor-default': this.disable,
            'font-size-18': this.tamanho != 'linha',
            'padding-0': this.tamanho == 'linha' || this.tamanho == 'clear'};

        let style = {
            'max-width': '400px',
            'padding': '20px',
            'border': '2px solid ' + this.config.colors.CorAbra,
            'border-radius': '20px'};

        if (result == 'color')                return color;
        if (result == 'stars')                return stars;
        if (result == 'style' && this.border) return style;

        return '';

    }

    hotstarMenu() {

        if (this.disable) return;

        alert('Estastística do Hotstar');

    }

}



// WEBPACK FOOTER //
// ./src/components/app-feedback/app-feedback.ts